import videojs from 'video.js';

export default function videoWatch() {
  videoWatchInit();
  $(document).on('turbolinks:load', videoWatchInit);
}

function videoWatchInit() {
  if ($('.js-overview-video').length) {
    Array.from(document.querySelectorAll('.js-overview-video')).forEach(
      videoEl => {
        const player = videojs(videoEl);
        const labelName = player.el().dataset.trackingLabelName;
        const variantName = player.el().dataset.trackingVariantName;

        let firstPlay = true;

        player.on('play', () => {
          if (firstPlay) {
            const courseId = player.el().dataset.courseId;

            const data = {
              course_id: courseId,
              event_type: 'video_watch',
              label_name: labelName,
              variant_name: variantName,
            };

            const url = `/course/${courseId}/segment`;

            $.ajax({
              type: 'POST',
              url: url,
              data: data,
              dataType: 'json'
            });

            firstPlay = false;
          }
        });
      }
    );
  }
}
